import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/system";

const Wrapper = styled('div')(({ theme }) => ({
  float: "right",
  right: theme.spacing(0.5),
  top: theme.spacing(0.5),
  position: "absolute",
}));

class ClosePopUpButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  render() {
    const { onClick } = this.props;
    return (
      <Wrapper>
        <IconButton onClick={onClick}>
          <CloseIcon />
        </IconButton>
      </Wrapper>
    );
  }
}

export default ClosePopUpButton;
